/**
 * Constants used by the module
 * To convert between different units and seconds
 */
const constants = {
    SECONDS_IN_YEAR: 31536000,
    SECONDS_IN_WEEK: 604800,
    SECONDS_IN_DAY: 86400,
    SECONDS_IN_HOUR: 3600,
    SECONDS_IN_MINUTE: 60,
    SECONDS_IN_MILLISECOND: 0.001,
    MILLISECONDS_IN_SECOND: 1000,
    ONE_SECOND: 1
};

module.exports = constants;


//////////////////
// WEBPACK FOOTER
// ./~/to-time/src/constants.js
// module id = 329
// module chunks = 0